export default {
  visa: '签证管理',
  employee: '员工管理',
  download: '下载中心',
  settings: '设置',

  // Data Summary routes
  dataSummary: '数据看板',
  dataOverview: '数据概览',
  headhunterBoard: '猎头推荐看板',
  internalBoard: '自设推荐看板',
  myBoard: '我的看板',

  // Job routes
  jobMananger: '招聘管理',
  job: '职位管理',
  jobForm: '创建职位',
  jobFormEdit: '编辑职位',
  jobDetail: '职位详情',
  agentManage: '猎头管理',
  agentJobList: '职位管理',
  businessManage: '招聘企业',

  // Headhunter Chat
  headhunterChat: '猎头沟通',
  companyChat: '企业沟通',

  // Candidate routes
  candidate: '候选人管理',
  candidateSelecting: '选考中候选人',
  candidateRegistered: '自社候选人',
  candidateEdit: '候选人编辑',
  candidateDetail: '候选人详情',
  candidateSelectingDetail: '选考中候选人详情',

  // Settings routes
  account: '账号管理',
  accountDetail: '个人信息',
  companySetting: '会社情報管理',
  departmentSetting: '所属先管理',
  interviewSetting: '选考设置',
  interviewProcess: '选考流程',
  interviewProcessDetail: '选考流程详情',
  interviewChannel: '应聘渠道',
  notify: '消息中心',
  notifySettings: '消息设置',

  // Error pages
  error404: '404',
  error403: '403',
};
